import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import VillaDetail from './VillaDetail';
import Layout from './Layout';
import { villasService } from '../services/api';

const VillaDetailWrapper = () => {
  const { villaId } = useParams();
  const [villaData, setVillaData] = useState(null);
  const [showBooking, setShowBooking] = useState(false);

  useEffect(() => {
    const fetchVillaForNav = async () => {
      try {
        const response = await villasService.getVillaById(villaId);
        if (response.success && response.data) {
          setVillaData({
            propertyType: response.data.type_of_house || 'Villa'
          });
        }
      } catch (error) {
        console.error('Error fetching villa for navigation:', error);
      }
    };

    if (villaId) {
      fetchVillaForNav();
    }
  }, [villaId]);

  return (
    <Layout 
      villaData={villaData} 
      onBooking={() => setShowBooking(true)}
    >
      <VillaDetail initialShowBooking={showBooking} />
    </Layout>
  );
};

export default VillaDetailWrapper;

